import * as Sentry from '@sentry/browser';

const sentryConfig = {
    ...window.sentryClientConfig,
    integrations: [
        // integration,
        Sentry.thirdPartyErrorFilterIntegration({
            filterKeys: ['discordhelp-site-bundle'],
            behaviour: 'drop-error-if-exclusively-contains-third-party-frames'
        })
    ]
};

Sentry.init(sentryConfig);

// const integration = {
//     name: "MyAwesomeIntegration",
//     processEvent(event, hint, client) {
//         console.log(event);
//         event.extra = {
//             ...event.extra,
//             myCustomTag: "value",
//         };
//         // Return the modified event,
//         // or return `null` to drop the event
//         return event;
//     },
// };

// beforeSend(event, hint) {
//     console.log(event);
//     console.log(hint);
//     // Example: Check if the error originated from an onclick handler
//     if (hint.originalException && hint.originalException.stack.includes('onclick')) {
//         // Option 1: Modify the event (e.g., add a tag)
//         event.tags = {...event.tags, source: 'onclick'};
//         return event;
//
//         // Option 2: Drop the event
//         // return null;
//     }
//
//     return event;
// },